import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'

export default {
    getShippingLabels({ commit }, payload = {
        paginate: '',
        query: ''}) {
        commit('GET_SHIPPING_LABELS_REQUEST')

        const paginate = payload.paginate,
            query = payload.query

        return axios
            .get(`/shipping-labels/shipping-labels${paginate}${query}`)
            .then(response => {
                commit('GET_SHIPPING_LABELS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_SHIPPING_LABELS_FAILURE')
                handleApiError(error, 'Pobranie listy zawieszek nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getShippingLabel(context, id) {
        return axios
            .get(`/shipping-labels/shipping-labels/${id}`)
            .then(response => {

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie danych dla zawieszki nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createFromShipmentsOrder({ commit }, payload) {
        return axios
            .post('/shipping-labels/shipping-label-from-shipping-order', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zawieszka została utworzona.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie zawieszki nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createFromEcommerceOrder({ commit }, payload) {
        return axios
            .post('/shipping-labels/shipping-label-from-ecommerce-order', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zawieszka została utworzona.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie zawieszki nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateShippingLabel({ commit }, shippingLabel) {
        return axios
            .put(`/shipping-labels/shipping-labels/${shippingLabel.id}`, shippingLabel)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zawieszka została zapisana.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja zawieszki nie powiodła się.')

                return Promise.reject(error)
            })
    },
    printShippingLabel(context, payload) {
        return axios
            .post('/shipping-labels/print-shipping-label', payload, {
                responseType: 'arraybuffer'
            })
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie wydruków nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createCarrierLabel(_, payload) {
        return axios
            .post('/shipping-labels/carrier-label', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie etykiety kurierskiej nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createAdditionalShippingLabel(_, payload) {
        return axios
            .post('/shipping-labels/additional-label', payload)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie zawieszki dodatkowej nie powiodło się.')

                return Promise.reject(error)
            })
    },
    deleteShippingLabel({ commit }, id) {
        return axios
            .delete(`/shipping-labels/shipping-labels/${id}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zawieszka została usunięta.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie zawieszki nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getShippingLabelTemplates({ commit }, payload = {query: ''}) {
        const query = payload.query

        return axios
            .get(`/shipping-labels/dicts/shipping-label-templates${query}`)
            .then(response => {
                commit('GET_SHIPPING_LABEL_TEMPLATES_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie dostępnych szablonów nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getShippingLabelStatuses({ commit }) {
        return axios
            .get('/shipping-labels/dicts/shipping-label-statuses')
            .then(response => {
                commit('GET_SHIPPING_LABEL_STATUSES', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie statusów zawieszek nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getShippingLabelTypes({ commit }) {
        return axios
            .get('/shipping-labels/dicts/shipping-label-types')
            .then(response => {
                commit('GET_SHIPPING_LABEL_TYPES', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie typów zawieszek nie powiodło się.')

                return Promise.reject(error)
            })
    },
    getShippingLabelDestinations() {
        return axios
            .get('/shipping-labels/dicts/shipping-label-destinations')
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Pobranie miejsc przeznaczenia nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateShippingLabeGood({ commit }, payload) {
        return axios
            .put(`shipping-labels/shipping-labels/position-available-goods/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Towar został zaktualizowany.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja towaru nie powiodła się.')

                return Promise.reject(error)
            })
    },
    createShippingLabelPackageConfiguration({ commit }, payload) {
        return axios
            .post('shipping-labels/shipping-labels/position-available-goods-packages-configurations', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Opakowanie zostało dodane.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie opakowania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    updateShippingLabelPackageConfiguration({ commit }, payload) {
        return axios
            .put(`shipping-labels/shipping-labels/position-available-goods-packages-configurations/${payload.id}`, payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Opakowanie zostało zaktualizowane.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Edycja opakowania nie powiodła się.')

                return Promise.reject(error)
            })
    },
    deleteShippingLabelPackageConfiguration({ commit }, id) {
        return axios
            .delete(`shipping-labels/shipping-labels/position-available-goods-packages-configurations/${id}`)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Opakowanie zostało usunięte.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Usunięcie opakowania nie powiodło się.')

                return Promise.reject(error)
            })
    },
    createShippingLabelFromCampaign({ commit }, payload) {
        return axios
            .post('/shipping-labels/shipping-label-from-campaign', payload)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: 'Zawieszka została utworzona.'
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Dodanie zawieszki nie powiodło się.')

                return Promise.reject(error)
            })
    },
}